// @ts-nocheck
import { Column } from 'react-table'
import { TitleCell } from './TitleCell'
import { UserCustomHeader } from './CustomHeader'
import { ActionCell } from './ActionCell'
import moment from 'moment'
import { EventStatuCell } from './EventStatusCell'
import { ActiveCell } from './ActiveCell'

const bookingsColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Title' className='min-w-50px' />,
    id: 'title',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index].title} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Room' className='min-w-50px' />
    ),
    id: 'room',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index].roomDetail?.roomName} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Start Date' className='min-w-50px' />
    ),
    id: 'start_date',
    Cell: ({ ...props }) => <TitleCell userObj={moment(props.data[props.row.index].startDate).locale("de").format('DD/MM/YYYY')} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='End Date' className='min-w-50px' />
    ),
    id: 'end_date',
    Cell: ({ ...props }) => <TitleCell userObj={moment(props.data[props.row.index].endDate).locale("de").format('DD/MM/YYYY')} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Status' className='min-w-50px' />
    ),
    id: 'approved',
    Cell: ({ ...props }) => <ActiveCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Action' className='min-w-75px' />
    ),
    id: 'action',
    Cell: ({ ...props }) => <ActionCell user={props.data[props.row.index]} />,
  },
]

export { bookingsColumns }
